import {
  ConfirmPhoneVerificationPayload,
  StartPhoneVerificationPayload,
  UserPhone,
  user,
} from '@api/api/user-schema';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const getUserPhone = () =>
  wretchRequest<UserPhone>(user.phone.get.path, {
    schema: user.phone.get.schema,
  });

export const startPhoneVerification = (body: StartPhoneVerificationPayload) =>
  wretchRequest(user.phone.startVerification.path, {
    method: 'post',
    body,
    handledErrorCodes: [400, 409, 429, 500, 502, 503],
  });

export const confirmPhoneVerification = (
  body: ConfirmPhoneVerificationPayload
) =>
  wretchRequest(user.phone.confirmVerification.path, {
    method: 'post',
    body,
    handledErrorCodes: [400, 409, 429, 500, 502, 503],
  });

export const deleteUserPhone = () =>
  wretchRequest(user.phone.delete.path, {
    method: 'delete',
    handledErrorCodes: [400, 429, 500, 502, 503],
  });
